export enum TenantType {
    Regular = 1,
    Demo = 2,
    Test = 3,
    Pilot = 4
}